module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-3000.10d43c56.svg";